import globalAxios from "../GlobalAxios";

const loginApi = async (email, password) => {
    const credentials = btoa(`${email}:${password}`);
    const result = await globalAxios.post("/api/auth/admin/login", {}, {
        headers: {
            'Authorization': `Basic ${credentials}`
        },
        withCredentials: true
    });
    return result.data;
};

const logoutApi = async () => {
    try {
        await globalAxios.post('/api/auth/admin/logout');
        sessionStorage.removeItem('AdminAccessToken');
    } catch (error) {
        console.error('error', error);
    }
};

const qnaApi = async () => {
    try {
        const res = await globalAxios.get('/api/admin/qna');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const userListApi = async () => {
    try {
        const res = await globalAxios.post('/api/admin/userInfo');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const statApi = async () => {
    try {
        const res = await globalAxios.post('/api/admin/stat');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const downloadApi = async () => {
    try {
        const res = await globalAxios.post('/api/admin/download-info');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const vodStatsApi = async () => {
    try {
        const res = await globalAxios.get('/api/admin/vod-stats');
        return res.data;
    } catch (error) {
        console.error("error", error);
        throw error;
    }
}


export default {
    loginApi,
    logoutApi,
    qnaApi,
    userListApi,
    statApi,
    downloadApi,
    vodStatsApi
};
